// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/kpis/kpis.less
// module id = 3648
// module chunks = 0